import { cn } from "../../utils";
import type { MenuDivider as MenuDividerType } from "./types";

type Props = {
  item: MenuDividerType;
};

export const MenuDivider = ({ item }: Props) => {
  return (
    <div
      className={cn("m-1 h-px bg-neutral-500/10", item.className)}
      role="separator"
    />
  );
};
